import React from "react";
import { useConfig } from "~/hooks/webconfig";
import { Card, CardContent, CardHeader, CardTitle } from "@mindstonehq/ui";
import { Trans } from "@lingui/react/macro";

export default function MindspaceEventMap({ address }: { address: string }) {
  const config = useConfig();

  return (
    <Card>
      <CardHeader>
        <CardTitle><Trans>Location</Trans></CardTitle>
      </CardHeader>
      <CardContent>
        <iframe
          height="260"
          style={{
            borderRadius: 12,
            width: "100%",
          }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps/embed/v1/place?key=${
            config.googleApiKey
          }&q=${encodeURIComponent(address.replace(", ", ","))}&zoom=15`}
        ></iframe>
      </CardContent>
    </Card>
  );
}
